<template>
    <!-- ======= Report Presentation"-->
    <div style="height: 300px; background-color: whitesmoke;" v-if="showbg">
      <img :src="`${bgimage}`" class="bgimage"/>
    </div>
   
    <div class="reportdiv" style="margin-top: -150px;">
      <div class="reportinnerdiv card shadow">
        <div class="rpttitle">{{ singlereporttitle }}</div>
        <div v-if="showrptfulltext">
          <div  v-html="rptfulltext" class="rptfulltext" ></div>
        </div>
        <div class="row align-items-start">
          <div class="col-xs-12 col-sm-12 col-md-4">
            <img :src="`${rpcoverpageimagepath}`" class="imgtxt imgwidth" />
          </div>
          <div class="col-xs-12 col-sm-12 col-md-4 middlecol">
            <div class="singletitle">{{ singlereporttitle }}</div>
            <div class="rplname">{{ rplinkname }}</div>
          </div>
          <div class="col-xs-12 col-sm-12 col-md-4">
            <div v-for="rpt in reportpresentation">
              <ul>
                <li class="linkformat1"><i class="fa-solid fa-link" style="font-size: 20px; padding-right: 10px; color: orangered;"></i>
                  <a :href="`${myPicUrl}${ rpt.rppdfpath }`" class="linkformat">{{ rpt.rptitle }}</a><br />
                  <span class="datecss">{{ dateTime(rpdate)}}</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>

  <!--  -->
     <!-- End Services Section -->
</template>
<script>
import axios from 'axios';
require('@/globalDeclare.js');
import moment from 'moment';

export default{
name: 'AllReports',

props: ['lastrecordsreportpresent', 'reportpresentation', 'openpdf', 'bgimage', 'reportpresenttheme', 'showbg',
    'singlereporttitle', 'rptfulltext', 'rpcoverpageimagepath', 'rplinkname', 'showrptfulltext',
    ],
data() {
  return {
    href: '',
    myPicUrl: '',
  }
},
methods: {
  dateTime(value) {
      return moment(value).format('YYYY-MMMM-DD');
    },
  },
mounted() {
  this.myPicUrl = myUrlPath
}
}
</script>
<style scoped>
img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  background-color: #003;
}
.imgtxt {
  width: 300px;
}
.reportdiv {
  padding: 200px;
  margin-top: -100px;
}

.reportinnerdiv {
  border: solid 3px rgb(113, 139, 155);
  padding: 20px;
  border-radius: 5px;
}
.rpttitle, .rpttitle1 {
  font-size: 30px;
  font-family:Verdana, Geneva, Tahoma, sans-serif;
  text-align: center;
  padding: 20px;
  font-weight: bolder;
  color: goldenrod;
}

.rpttitle1 {
  margin-top: -100px;
  padding-bottom: 80px;
}
.middlecol {
  text-align: center;
  border-left: thin solid rgb(152, 165, 172);
  border-right: thin solid rgb(152, 165, 172);
  height: 260px;
}
.singletitle {
  margin-top: 30px;
  color: #003;
  font-weight: bold;
}
.rplname {
  padding-top: 40px;
  color:rgb(24, 74, 121);
  font-weight: bold;
}
.linkformat {
  text-decoration: none;
  color:rgb(24, 74, 121);
  font-weight: bold;
  font-size: 20px;
}
.linkformat1 {
  list-style-type: none;
}
.datecss {
  font-style: italic;
  color:rgb(152, 165, 172);
  font-weight: bold;
}

/*Reccent Documents*/
.recentdocdiv, .passreports {
 padding-bottom: 100px;
 padding-top: 50px;
}
.imgwidth {
  width: 100%;
  padding-left: 60px;
  padding-right: 60px; 
}
.bgimage {
  width: 100%; 
  height: 440px;
}
.rptfulltext {
  text-align: justify;
  color: #003;
}
/*===================MEDIA SCREENS TAMPLATES===============*/
 /* Extra small devices (phones, 600px and down) */
 @media only screen and (max-width: 600px) {
  .reportdiv {
    padding: 20px;
    margin-top: 100px;
  }
  .bgimage {
    width: 100%; 
    height: 200px;
  }
  .rptfulltext {
    padding-right: 20px;
    padding-left: 20px;
  }
 }

 /* Small devices (portrait tablets and large phones, 600px and up) */
 @media only screen and (min-width: 600px) {
 .reportdiv {
    padding: 20px;
    margin-top: 100px;
  }
  .imgtxt {
    width: 100%;
  }
  .rptfulltext {
    padding-right: 20px;
    padding-left: 20px;
  }
 }
 
 /* Medium devices (landscape tablets, 768px and up) */
 @media only screen and (min-width: 768px) {
  .reportdiv {
    padding: 30px;
    margin-top: 100px;
  }
  .imgwidth {
    width: 100%;
    padding-left: 10px;
    padding-right: 10px; 
    margin-top: 10px;
  }
 }
 
 /* Large devices (laptops/desktops, 992px and up) */
 @media only screen and (min-width: 992px) {
  .reportdiv {
    padding: 100px;
    margin-top: 100px;
  }
  .imgwidth {
    width: 100%;
    padding-left: 30px;
    padding-right: 30px; 
  }
  .rptfulltext {
    padding-right: 100px;
    padding-left: 100px;
  }
 }


 
 /* Extra large devices (large laptops and desktops, 1200px and up) */
 @media only screen and (min-width: 1200px) {
  .reportdiv {
    padding: 100px;
    margin-top: 100px;
  }
  .imgwidth {
    width: 100%;
    padding-left: 37px;
    padding-right: 37px; 
  }
 } 

/* Extra large devices (large laptops and desktops, 1200px and up) */
@media only screen and (min-width: 1400px) {
    .reportdiv {
      padding-left: 200px;
      padding-right: 200px;
    }
    .imgwidth {
      width: 100%;
      padding-left: 60px;
      padding-right: 60px; 
    }
  }
  
@media only screen and (min-width: 1600px) {
  .imgwidth {
    width: 100%;
    padding-left: 70px;
    padding-right: 70px; 
  }
  } 



</style>